import { render, staticRenderFns } from "./Contatti.vue?vue&type=template&id=218a963f"
import script from "./Contatti.vue?vue&type=script&lang=js"
export * from "./Contatti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports